import { render, staticRenderFns } from "./UnderWritingQuestionsActivities.vue?vue&type=template&id=6891cda0"
import script from "./UnderWritingQuestionsActivities.vue?vue&type=script&lang=ts"
export * from "./UnderWritingQuestionsActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports